
import _ from 'lodash'
import React, { Component } from "react";
import { connect } from "react-redux";
import {  reduxForm, propTypes } from 'redux-form'
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  InputGroup
} from "react-bootstrap"
import { PropTypes } from "prop-types"
import { URL } from '../../../config'
import userManager from '../../../userManager'
import ContentWrapper from "../../layout/ContentWrapper"
import { getRequest } from '../../../utils/httpRequest'
import { orange,gender,division } from '../../../utils/constants'
import ReconcileEvent from './ReconcileEvent'
import AmendScores from './AmendScores'
import { getParticipants, getGames } from './api'

const resetScreen = {
  searchExceptions:false,
  amendScores:false,
  eventSet:false,
  localMode:true,
  schools:[]  
}

class Reconciliation extends Component {
 
  static propTypes = {
    ...propTypes
  }
  constructor(props)
  {
    super(props)
    const eventId = props.location.state != undefined ? props.location.state.eventId : -1;
    const eventSetStatus = eventId > -1 ? true : false;

    this.state = {
      reconcileBy:this.ReconcileBy.System,
      eventDivision:division.Varsity,
      eventGender:gender.Men,
      rankedEvents:[],
      teamScores:{},
      eventId:eventId,
      eventSet:eventSetStatus,
      eventChanged:false,
      searchExceptions:false,
      amendScores:false,
      schoolId:-1,
      eventName:'',
      schools: []
    }
    this.getRankedEvents   = this.getRankedEvents.bind(this)
    this.populateEvents    = this.populateEvents.bind(this)
    this.handleEventChange = this.handleEventChange.bind(this)
    this.handleReconciliationTypeChange = this.handleReconciliationTypeChange.bind(this)
    this.handleDivisionChange = this.handleDivisionChange.bind(this)
    this.handleSearch         = this.handleSearch.bind(this)
    this.handleGenderChange   = this.handleGenderChange.bind(this)
    this.populateScores       = this.populateScores.bind(this)
    this.handleSchoolChange   = this.handleSchoolChange.bind(this)
    this.getEventParticipants =  this.getEventParticipants.bind(this)
  }

  componentDidMount()
  {
    const { oidc } = this.props
    if (oidc.user == null)
    {
      const _this = this
      userManager.signinRedirect().then(function() {
        _this.getRankedEvents()
      })
    }
    else
    { 
      this.getRankedEvents()
      // console.log("componentDidMount: ", this.props);
    }
  }
  ReconcileBy =
  {
    System:'system',
    Score:'score'
  }
  handleEventChange(event)
  {
    const { rankedEvents,reconcileBy }= this.state
    const eventId = event.target.value
    let eventName = ''
    
    if(eventId != -1)
    {
      if(reconcileBy == this.ReconcileBy.Score)
      {
        this.getEventParticipants(eventId)
      }
      eventName = _.find(rankedEvents,['eventId',parseInt(eventId)]).eventName
    }
    this.setState({ 
      eventId:eventId,
      eventChanged:true,
      eventName,
      ...resetScreen
    })
  }
  handleReconciliationTypeChange = (event) => {
    const reconcileBy = event.target.value
    const { eventId } = this.state
   
    // console.log('handleReconciliationTypeChange reconcileBy,eventId,eventGender: ',reconcileBy,eventId,eventGender)

    if((reconcileBy == this.ReconcileBy.Score) && (eventId != -1))
    {
      this.getEventParticipants(eventId);
    }

    this.setState({ 
      reconcileBy:reconcileBy,
      ...resetScreen
     })
  }
  handleDivisionChange(event)
  {
    const eventDivision = event.target.value
    this.setState({ 
      eventDivision,
      ...resetScreen
    })
  }
  handleSchoolChange(event)
  {
    const schoolId = event.target.value
    this.setState({ 
      schoolId,
      amendScores:false
    })
  }
  handleGenderChange(event)
  {
    const eventGender = event.target.value
    this.setState({ 
      eventGender,
      ...resetScreen
    })
  }
  handleSearch()
  {
    const { 
      reconcileBy ,
      eventId,
      schoolId,
      eventDivision,
      eventGender
    } = this.state
   
    if(reconcileBy == this.ReconcileBy.System)
    { /*  System Exceptions */
      this.setState({ searchExceptions:true })
    }
    else
    { /** Amend Scores */
      const token   = this.props.oidc.user.access_token
      const _this = this;
      getGames(eventId,schoolId,eventDivision,eventGender,token).then(function(response){
        _this.setState({ amendScores:true,
          teamScores:response.data,
        });        
      })

      //  console.log(`${componentName} handleSearch schoolName ${schoolName}, schoolId ${schoolId}, eventDivision ${eventDivision}`)
    }
  }
  getRankedEvents()
  {
    const rankedEventsEndpoint = '/rankedevents'
    const token = this.props.oidc.user.access_token
    const  rankedEventsURL =  `${URL.event}${rankedEventsEndpoint}` 
    const _this = this
    // console.log("this.props b4 getting events: ",this.props);
    getRequest(rankedEventsURL,'json',token).then(function(response){
      _this.setState({ 
        rankedEvents:response.data
      })
    })
  }
  getEventParticipants(eventId)
  {
    
    const token   = this.props.oidc.user.access_token
    const _this = this
    getParticipants(eventId,token).then(function(response){
      _this.setState({ 
        schools:response.data
      })
    })
  }
  populateEvents()
  {
    // console.log('Populating events')
    // console.log('this.state.rankedEvents: ',this.state.rankedEvents)
    // console.log('populateEvents() eventId: ',this.state.eventId)
    const rankedEvent = this.state.rankedEvents.map((rankedEvent) => {
      return (<option key={rankedEvent.eventId} value={rankedEvent.eventId}>{rankedEvent.eventName}</option>)
    })
    return rankedEvent
  }
  populateSchools()
  {
    // console.log('Populating schools')
    // console.log('this.state.schools: ',this.state.schools)
    // console.log('populateSchools() eventId: ',this.state.eventId)
    // console.log('populateSchools() schoolId: ',this.state.schoolId)
    if (this.state.schools.length == 0  && this.state.eventId != -1 ){      
      this.getEventParticipants(this.state.eventId)
    }
    const schools = this.state.schools.map((school) => {
      return (<option key={school.usbcSchoolId} value={school.usbcSchoolId}>{school.teamName}</option>)
    })
    return schools
  }
  populateScores(schoolName)
  {
   //return this.games;
   const {      
    eventId,
    schoolId,
    eventDivision,
    eventGender
  } = this.state
    const token   = this.props.oidc.user.access_token
    let gamesData =[];
    getGames(eventId,schoolId,eventDivision,eventGender,token).then(function(response){
      gamesData = response.data;
    })
   //
   const noOfStandardGames =parseInt(gamesData.numberStandardGames);
  const returnSet = {
    usbcSchoolId:gamesData.usbcSchoolId,
    schoolName:schoolName,
    numberStandardGames: noOfStandardGames,//4,
    numberBakerGames:5,
    standardGames:[
      {
         bowlerId:'15-132269',
         bowlerName:'Madison Laney',
         scores: [
           { IndividualGameScoreId: 1046,
             gameNo: 1,
             score: 0 
           },
           { IndividualGameScoreId: 1058,
             gameNo: 2,
             score: 194 
           },
           { IndividualGameScoreId: 1045,
             gameNo: 3,
             score: 171 
           },
           { IndividualGameScoreId: 1043,
             gameNo: 4,
             score: 203 
           },
           { IndividualGameScoreId: 1042,
             gameNo: 5,
             score:  181
           },
           { IndividualGameScoreId: 1041,
             gameNo: 6,
             score: 181 
           }
         ]
      }
    ],
    bakerGames:{
     scores:[
      {
        game:1,
        score:100
      },
      {
       game:2,
       score:115
     },
     {
       game:3,
       score:132
     },
     {
       game:4,
       score:109
     },
     {
       game:5,
       score:130
     }
    ],
     bowlers:[
       {
         name:'Martin Smith',
         memberId:'111-222222',
         bowled:'Yes'
       },
       {
         name:'Paul Martin',
         memberId:'121-33333',
         bowled:'Yes'
       },
       {
         name:'Jesus Rodriguez',
         memberId:'44-235522',
         bowled:'Yes'
       },
       {
         name:'Ted Cruz',
         memberId:'111-222222',
         bowled:'Yes'
       },
       {
         name:'Carlos Lescay',
         memberId:'111-222222',
         bowled:'No'
       }

     ]
   }
} 
return returnSet;

  } 
  render()
    {
      const { ReconcileBy } = this
      const { 
        reconcileBy,
        eventSet,
        eventChanged,
        searchExceptions,
        amendScores,
        eventGender,
        teamScores,      
        schoolId,
        eventId,
        eventName
      } = this.state

      const { location } = this.props
      const { state }    = location
   
      const action        = state != undefined ? state.action:'Reconcile'
      const exceptionType = state != undefined ? state.exceptionType:'all'
      const disableSearch = (this.state.eventId == -1 || searchExceptions || (reconcileBy == ReconcileBy.Score && schoolId == -1)  )
      const schoolBorderColor = schoolId == -1 ? 'red':''

      return (
        <ContentWrapper>
        <div className="content-heading">Results Reconciliation</div>
        <div>
          <Row>
            <Col sm={12}>
              <div className="stacked-filter-panel">
                <FormGroup controlId="searchby" className="searchby-filter">
                  <FormControl  value={this.state.eventId} componentClass="select" placeholder="All" onChange = { this.handleEventChange } style={{ minWidth:'475px',borderRadius:'0' }}>
                    <option value='-1'>Select an event...</option>
                    {this.populateEvents(this.state.eventId)}
                  </FormControl>
                  <FormControl  defaultValue={ReconcileBy.System} componentClass="select" placeholder="All" onChange = { this.handleReconciliationTypeChange } style={{ minWidth:'170px',borderRadius:'0' }}>
                    <option value={ReconcileBy.System}>System exceptions</option>
                    <option value={ReconcileBy.Score}>Amend scores</option>
                  </FormControl>
                  <InputGroup>              
                   {  
                      reconcileBy == ReconcileBy.Score && 
                      (
                        [ <FormControl key='schools'  componentClass="select" value={this.state.schoolId}
                            placeholder="All" 
                            onChange={this.handleSchoolChange } 
                            style={{ minWidth:'250px',borderRadius:'0',borderColor:schoolBorderColor }} 
                            disabled={eventId==-1}>
                              <option value={-1}>Select a school...</option>
                            {this.populateSchools()}
                          </FormControl>,
                          <FormControl key='division' defaultValue={division.Varsity} componentClass="select" placeholder="All" onChange = { this.handleDivisionChange } style={{ minWidth:'135px',borderRadius:'0' }}>
                            <option value={division.Varsity}>{division.Varsity}</option>
                            <option value={division.Junior}>{division.Junior}</option>
                          </FormControl>
                      ]
                      )
                    } 
                    {  
                      reconcileBy == ReconcileBy.Score && 
                      (<FormControl  defaultValue={eventGender} componentClass="select" placeholder="All" onChange = { this.handleGenderChange } style={{ minWidth:'105px',borderRadius:'0' }}>
                        <option value={gender.Men}>{gender.Men}</option>
                        <option value={gender.Women}>{gender.Women}</option>
                      </FormControl>)
                    }
                    <InputGroup.Button>
                      <Button onClick={this.handleSearch} style={{ color:orange, marginLeft:'-2px', minHeight:'35px' }} disabled={disableSearch}>
                        <i className="fa fa-search" aria-hidden="true" />
                      </Button>
                    </InputGroup.Button>                      
                </InputGroup>          
              </FormGroup>
            </div>
          </Col>
        </Row>
        <Row>
          {
            (searchExceptions || eventSet ) &&
            (<ReconcileEvent eventId={parseInt(this.state.eventId)} action={action} eventChanged={eventChanged} exceptionType={exceptionType} />)
          } 
           {
            amendScores &&
            (<AmendScores eventId={parseInt(this.state.eventId)} teamScores={teamScores} eventName={eventName} eventChanged={eventChanged}  />)
          } 
        </Row>
      </div>
    </ContentWrapper>        
    )
  }
}

Reconciliation.propTypes = {
  oidc: PropTypes.object,
  dispatch:PropTypes.func,
  reset:PropTypes.func,
  location:PropTypes.object
}
/* Reconciliation.propTypes = {
  handleOpenNewTournamentModal: func,
} */

const mapDispatchToProps = () => ({
 // handleOpenNewTournamentModal: () => dispatch(showModal("ADD_NEW_TOURNAMENT")),
})

const mapStateToProps = ({  oidc }) => {
	return {
		oidc: { ...oidc }
	}
}

export default reduxForm({
  form:'event'
})(connect(mapStateToProps,mapDispatchToProps)(Reconciliation))




// WEBPACK FOOTER //
// ./src/components/pages/Event/Reconciliation.js